import {
  ID,
  LifeArea,
  LocalizedLifeArea,
  Task,
  UpdateLifeArea,
} from '@griply/types';
import { taskLifeAreaIds } from '@griply/utils';

import { insertDuplicatesAfterSelection } from './insert-duplicates-after-selection';

export type UpdateLinkedLifeAreaOptions = {
  taskPairs: Array<{ oldTask: Task; newTask: Task }>;
  getLifeAreaDocById: (
    id: ID,
  ) => Promise<LifeArea | LocalizedLifeArea | undefined>;
  updateLifeArea: (lifeArea: UpdateLifeArea) => Promise<void> | void;
};

export const updateLinkedLifeArea = async ({
  taskPairs,
  getLifeAreaDocById,
  updateLifeArea,
}: UpdateLinkedLifeAreaOptions): Promise<void> => {
  const lifeAreaGroups = new Map<ID, Array<{ oldTask: Task; newTask: Task }>>();
  taskPairs.forEach(({ oldTask, newTask }) => {
    if (oldTask.parentIds?.length) {
      return;
    }
    // The duplicate belongs in the sorting of every life area the source was linked to.
    taskLifeAreaIds(oldTask).forEach((lifeAreaId) => {
      const existing = lifeAreaGroups.get(lifeAreaId) ?? [];
      lifeAreaGroups.set(lifeAreaId, [...existing, { oldTask, newTask }]);
    });
  });

  if (!lifeAreaGroups.size) {
    return;
  }

  await Promise.all(
    Array.from(lifeAreaGroups.entries()).map(async ([lifeAreaId, pairs]) => {
      const lifeArea = await getLifeAreaDocById(lifeAreaId);
      if (!lifeArea?.taskSorting?.length) {
        return;
      }

      const taskSorting = insertDuplicatesAfterSelection(
        lifeArea.taskSorting,
        pairs,
      );
      await updateLifeArea({ id: lifeArea.id, taskSorting });
    }),
  );
};
